import { render, staticRenderFns } from "./ProductType.vue?vue&type=template&id=50bb2610&"
import script from "./ProductType.vue?vue&type=script&lang=ts&"
export * from "./ProductType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports